import queryString from "query-string";
import React, { ReactElement, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { Application, ApplicationService } from "../";

import { object, string } from "yup";
import { InputErrorMessage, Loading } from "../../ui";

interface IProps {
	application: Application;
	jumpToStep?: any;
	nextStep: number;
}

export const StepOne = (props: IProps): ReactElement => {
	const [errors, setErrors] = useState(null);

	const [existingEmail, setExistingEmail] = useState("");
	const [existingApplicationId, setExistingApplicationId] = useState();
	const [existingError, setExistingError] = useState("");

	const applicationService = new ApplicationService();

	const schema = object({
		firstName: string().required("First Name is a required field"),
		lastName: string().required("Last Name is a required field"),
		phone: string().required("Phone number field is required"),
		email: string()
			.email("Email must be a valid email")
			.required("Email is a required field"),
	});

	const createApplication = async () => {
		if (props.application.currentStep === 0) {
			props.application.currentStep = 1;
		}
		await applicationService.createApplication(props.application);
		props.jumpToStep(1);
	};

	if (!props.application.lead) {
		return <Loading />;
	}

	const qs = queryString.parse(location.search);

	if (props.application.lead) {
		if (qs.firstName) {
			props.application.lead.firstName = qs.firstName as string;
		}

		if (qs.lastName) {
			props.application.lead.lastName = qs.lastName as string;
		}

		if (qs.email) {
			props.application.lead.email = qs.email as string;
		}
	}

	const validateStep = () => {
		if (props.application.lead) {
			schema
				.validate(
					{
						firstName: props.application.lead.firstName,
						lastName: props.application.lead.lastName,
						email: props.application.lead.email,
						phone: props.application.lead.phone,
					},
					{ abortEarly: false },
				)
				.then(valid => {
					if (valid) {
						setErrors(null);
						createApplication();
					}
				})
				.catch(err => {
					setErrors(err);
				});
		}
	};

	const checkExisting = async () => {
		setExistingError("");
		if (!existingApplicationId) {
			setExistingError("Please enter your application ID.");
			return;
		}

		if (!existingEmail) {
			setExistingError(
				"Please enter the email address you used for your application.",
			);
			return;
		}

		const app = await applicationService.getApplicationByApplicationId(
			String(existingApplicationId),
			existingEmail,
			props.application,
		);

		if (app === false) {
			setExistingError(
				"Application could not be found using the information provided.",
			);
		} else {
			props.jumpToStep(props.nextStep);
		}
	};

	const handleChangeFirstName = (event: any) => {
		if (props.application.lead) {
			props.application.lead.firstName = event.target.value;
		}
	};
	const handleChangeLastName = (event: any) => {
		if (props.application.lead) {
			props.application.lead.lastName = event.target.value;
		}
	};

	const handleChangeEmail = (event: any) => {
		if (props.application.lead) {
			props.application.lead.email = event.target.value;
		}
	};

	return (
		<>
			<Row>
				<Col className="pr-5">
					<Row>
						<Col xs={12}>
							<h5 className="mt-4 mb-4">
								Start a new Application
							</h5>
							<Form.Group controlId="firstName">
								<Form.Label>First Name</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={
										props.application.lead.firstName
									}
									onChange={handleChangeFirstName}
								/>
								<InputErrorMessage
									errors={errors}
									field="firstName"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<Form.Group controlId="lastName">
								<Form.Label>Last Name</Form.Label>
								<Form.Control
									size="lg"
									onChange={handleChangeLastName}
									defaultValue={
										props.application.lead.lastName
									}
								/>
								<InputErrorMessage
									errors={errors}
									field="lastName"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<Form.Group
								controlId="email"
								defaultValue={props.application.lead.email}
							>
								<Form.Label>Email</Form.Label>
								<Form.Control
									size="lg"
									onChange={handleChangeEmail}
									defaultValue={props.application.lead.email}
								/>
								<InputErrorMessage
									errors={errors}
									field="email"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col xs={12} className="mb-3">
							<Form.Group controlId="phone">
								<Form.Label>Mobile Number</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={props.application.lead.phone}
									onChange={(event: any) => {
										if (props.application.lead) {
											props.application.lead.phone =
												event.target.value;
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="phone"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={validateStep}
					>
						Start Application
					</Button>
				</Col>
				<Col>
					<h5 className="mt-4 mb-4">
						Continue an existing Application
					</h5>
					{existingError ? (
						<Alert variant="danger">{existingError}</Alert>
					) : null}
					<Row>
						<Col xs={12}>
							<Form.Group controlId="existingApplicationId">
								<Form.Label>Application ID</Form.Label>
								<Form.Control
									size="lg"
									onChange={(event: any) =>
										setExistingApplicationId(
											event.target.value,
										)
									}
								/>
							</Form.Group>
						</Col>

						<Col xs={12}>
							<Form.Group controlId="existingEmail">
								<Form.Label>Email</Form.Label>
								<Form.Control
									size="lg"
									onChange={(event: any) =>
										setExistingEmail(event.target.value)
									}
								/>
							</Form.Group>

							<Button
								variant="primary"
								size="lg"
								className="float-right btn-next"
								onClick={checkExisting}
							>
								Resume Application
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};
